import React, { useEffect, useRef, useState } from "react";
import {
  addCollege,
  getScholarship,
  updateCollegeDetails,
} from "../../../Services/HomeService";
import toast from "react-hot-toast";
import 'react-quill/dist/quill.snow.css';
import Select from "react-select";

const CollegeUniversityScholarshipStep1 = ({ data, setData, setCurrentStep, currentStep }) => {

  const initialValues = {
    scholarshipBannerHeading: data?.scholarshipBannerHeading,
    scholarships: data?.scholarships,
  }

  const [selectedScholarships, setSelectedScholarships] = useState([]);
  const [scholarshipOptions, setScholarshipOptions] = useState([])
  const [formData, setFormData] = useState(initialValues);
  const [formDataLoading, setFormDataLoading] = useState(false);

  const fetchAllScholarships = async () => {
    try {
      const res = await getScholarship();
      console.log("fetched Scholarship", res?.data);
      if (res?.status) {

        const options = res?.data.map(item => ({
          value: item._id,
          label: item.schemeName
        }));
        console.log("POI46", options);

        setScholarshipOptions(options);
      } else {
        toast.error("Error while Fetching Scholarship Data");
      }
    } catch (error) {
      console.error("Error fetching Scholarship:", error);
    }
  };

  const handleBack = (e) => {
    e?.preventDefault();
    setCurrentStep(currentStep - 1)
  }

  const handleUpdate = async (e) => {
    e?.preventDefault();

    try {
      setFormDataLoading(true);
      const values = selectedScholarships?.map(opt => opt.value);
      const formValues = {
        scholarshipBannerHeading: formData?.scholarshipBannerHeading,
        scholarships: values
      }
      console.log("KIU73", formValues);

      // return
      const res = await updateCollegeDetails(data?._id, formValues);
      console.log("College Add Step2 Message ", res);
      if (res?.status) {
        console.log("JUY79", selectedScholarships);

        // toast.success("Data saved successfully");
        setFormData(initialValues)
        setFormDataLoading(false);
        setData({
          ...data,
          scholarshipBannerHeading: formData?.scholarshipBannerHeading,
          scholarships: selectedScholarships,
        })
        setCurrentStep(currentStep + 1)
      } else {
        toast.error(res?.message);
        setFormDataLoading(false);
      }
    } catch (error) {
      toast.error("Failed to add College.");
      console.error("Error adding College:", error);
      setFormDataLoading(false);
    }
  };

  useEffect(() => {
    fetchAllScholarships()
  }, [])

  useEffect(() => {
    const values = selectedScholarships?.map(opt => opt.value);
    setFormData({ ...formData, scholarships: values })
  }, [selectedScholarships])

  useEffect(() => {
    const scholarshipOptionsData = data?.scholarships.map(item => ({
      value: item._id,
      label: item.schemeName
    }));

    setSelectedScholarships(scholarshipOptionsData)
    setFormData({ scholarshipBannerHeading: data?.scholarshipBannerHeading, scholarships: scholarshipOptionsData })
  }, [data])

  useEffect(() => {
    setFormData(initialValues)
  }, [data])

  return (
    <>

      <section className="chartBox_area">
        <form
          onSubmit={(e) => {
            handleUpdate(e);
          }}
        >
          <div className="row d-flex justify-content-center">

            <div className="col-md-12 mt-3">
              <label htmlFor="name">
                Scholarship Banner Heading<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                // value={formData?.scholarshipBannerHeading || data?.scholarshipBannerHeading}
                value={formData?.scholarshipBannerHeading}
                onChange={(e) => {
                  setFormData((prev) => ({
                    ...prev,
                    scholarshipBannerHeading: e?.target?.value,
                  }));
                }}
                placeholder="Enter heading text"
              />
            </div>

            <div className="col-md-12 mt-3">
              <label htmlFor="name">
                Scholarships<span className="text-danger">*</span>
              </label>
              <Select
                isMulti
                options={scholarshipOptions}
                value={selectedScholarships}
                onChange={setSelectedScholarships}
                placeholder="Select Schemes..."
              />
            </div>



          </div>
          <div className=" d-flex justify-content-end">
            {
              currentStep > 2 &&
              <button
                type="button"
                className="btn mt-3"
                style={{
                  background: "rgb(133, 218, 79)",
                  borderRadius: "13px",
                  marginRight: "15px"
                }}
                onClick={(e) => handleBack(e)}
              >Back
              </button>
            }

            <button
              disabled={formDataLoading}
              type="submit"
              className="btn mt-3"
              style={{
                background: "rgb(133, 218, 79)",
                borderRadius: "13px",
              }}
            >
              {formDataLoading
                ? "Saving..."
                // : "Add College/University"
                : `Save & Continue`
              }
            </button>
          </div>
        </form>
      </section>

    </>
  );
};

export default CollegeUniversityScholarshipStep1;
